interface AudienceItem {
    id: string;
    name: string;
    price: number;
    quantity: number;
}

export class CartModel {
    private items: Map<string, AudienceItem>;
    private total: number;
    private eventId: string;
    private sessionId: string;

    constructor() {
        this.items = new Map();
        this.total = 0;
        this.eventId = document.querySelector('[data-event-id]')?.getAttribute('data-event-id') || '';
        this.sessionId = document.querySelector('[data-session-id]')?.getAttribute('data-session-id') || '';
    }

    addItem(id: string, name: string, price: number, quantity: number): void {
        const existingItem = this.items.get(id);
        if (existingItem) {
            existingItem.quantity = quantity;
        } else {
            this.items.set(id, { id, name, price, quantity });
        }
        this.calculateTotal();
    }

    removeItem(id: string): void {
        this.items.delete(id);
        this.calculateTotal();
    }

    updateQuantity(id: string, quantity: number): void {
        const item = this.items.get(id);
        if (item) {
            item.quantity = quantity;
            this.calculateTotal();
        }
    }

    getTotal(): number {
        return this.total;
    }

    getItems(): AudienceItem[] {
        return Array.from(this.items.values());
    }

    private calculateTotal(): void {
        this.total = Array.from(this.items.values())
            .reduce((sum, item) => sum + (item.price * item.quantity), 0);
    }
    
} 